import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import {ConfigProvider, ConfigProviderProps} from 'antd';
import './index.css';
import '@/i18n/i18n.ts';
import {Provider} from "react-redux";
import store from '@/redux/store';
import {LocalStorage} from "@/common/storage.ts";
import {LANGUAGE_OPTION} from "@/constant/constants.ts";
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from "react-toastify";
import enUS from 'antd/locale/en_US';
import jaJP from 'antd/locale/ja_JP';

type Locale = ConfigProviderProps['locale'];

const getLocale = (): Locale => {
    const lang = LocalStorage.getLang() || LANGUAGE_OPTION.ENGLISH;
    return lang === LANGUAGE_OPTION.JAPAN ? jaJP : enUS;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    // <React.StrictMode>
    <ConfigProvider
        theme={{
            token: {
                fontFamily: (LocalStorage.getLang() || LANGUAGE_OPTION.ENGLISH) === LANGUAGE_OPTION.JAPAN ? "Noto Sans JP" : "Sarabun",
                colorText: '#556476',
                colorPrimary: '#4A58EC',
            },
            components: {
                Menu: {
                    itemColor: '#556476',
                    itemHoverBg: '#F4F7FF',
                    itemHoverColor: '#4154F1',
                    itemSelectedColor: '#4A58EC',
                    itemSelectedBg: '#F4F7FF',
                    groupTitleFontSize: 12,
                    groupTitleColor: "#899BBD",
                },
                Button: {
                    fontWeight: 500,
                    colorPrimaryBgHover: '#dfe0fd',
                    colorPrimaryActive: '#BFC5FF',
                    borderColorDisabled: 'none',
                },
                Layout: {
                    headerBg: '#FFFFFF',
                    headerHeight: 72,
                    bodyBg: '#EDF1F7'
                },
                Progress: {
                    remainingColor: 'transparent',
                    lineBorderRadius: 0
                }
            },
        }}
        locale={getLocale()}
    >
        <Provider store={store}>
            <App/>
            <ToastContainer/>
        </Provider>
    </ConfigProvider>,
    // </React.StrictMode>,
)
